import { Injectable } from "@angular/core";
import { ArchiveEntityRequest, ExerciseFieldsWithIdsResponse, ExerciseFindFilteredRequest, ExerciseFindFilteredResponse, FavoriteExerciseRequest, GetCountExercisesResponse, GetExerciseImagesRequest, GetExerciseImagesResponse, ShareExercisesWithOrgRequest, SuccessResponse, UpsertExerciseRequest } from "@me-fit-mono/typings";
import { ME_Fit } from "me-fit-typings";
import { environment } from "src/environments/environment";
import { StateManagerService } from "./state-manager.service";
import { OrganizationStateService } from "./organization.state.service";
import { EmployeesStateService } from "./employees.state.service";

type ExercisePathPart = {
  id: string;
}

@Injectable({
  providedIn: 'root'
})
export class ExerciseStateService {
  private API_EXERCISES = `${environment.API_ENDPOINT}/exercises`;

  fields = this.$state.createState<void, ExerciseFieldsWithIdsResponse>({
    httpMethod: 'get',
    path: `${this.API_EXERCISES}/fields-with-ids`,
  });

  upsert = this.$state.createState<UpsertExerciseRequest, ME_Fit.Exercise>({
    httpMethod: 'post',
    path: `${this.API_EXERCISES}/upsert`,
    onNewResponse: () => {
      this.$employees.getExerciseFavorites.call();
      this.$organisation.getExerciseFavorites.call();
    }
  });

  getCount = this.$state.createState<void, GetCountExercisesResponse>({
    httpMethod: 'get',
    path: `${this.API_EXERCISES}/count`,
  });

  shareExercisesWithOrg = this.$state.createState<ShareExercisesWithOrgRequest, SuccessResponse>({
    httpMethod: 'post',
    path: `${this.API_EXERCISES}/share-with-organization`,
  });

  get = this.$state.createState<void, ME_Fit.Exercise, ExercisePathPart>({
    httpMethod: 'get',
    path: `${this.API_EXERCISES}/:id`,
  });

  archive = this.$state.createState<ArchiveEntityRequest, SuccessResponse, ExercisePathPart>({
    httpMethod: 'patch',
    path: `${this.API_EXERCISES}/:id/archive`,
  });

  getImage = this.$state.createState<GetExerciseImagesRequest, GetExerciseImagesResponse>({
    httpMethod: 'post',
    path: `${this.API_EXERCISES}/images`,
  });

  findFiltered = this.$state.createState<ExerciseFindFilteredRequest, ExerciseFindFilteredResponse>({
    httpMethod: 'post',
    path: `${this.API_EXERCISES}/filtered`,
  });

  remove = this.$state.createState<void, SuccessResponse, ExercisePathPart>({
    httpMethod: 'delete',
    path: `${this.API_EXERCISES}/:id`,
  });

  favoriteExercise = this.$state.createState<FavoriteExerciseRequest, SuccessResponse, ExercisePathPart>({
    httpMethod: 'patch',
    path: `${this.API_EXERCISES}/:id/favorite`,
    onNewResponse: (state) => {
      if (state.request?.favoriteType === "employee" && state.response?.success ) {
        this.$employees.getExerciseFavorites.call();
      }

      if (state.request?.favoriteType === "organization" && state.response?.success) {
        this.$organisation.getExerciseFavorites.call();
      }
    }
  });

  constructor(
    private $state: StateManagerService,
    private $organisation: OrganizationStateService,
    private $employees: EmployeesStateService,
  ) {}
}
